import { emptyToNull } from '../../utils/form';
import type { CompanyFormValidated, CompanyFormValues } from './schemas';
import {
  buildSectionContextRequest,
  sectionContextToFormValues,
} from './section-context-transformers';
import type { CompanyRequest } from './types/api';
import type { CompanyDetail } from './types/company';

/** Map an API company detail response onto the form's editable state. */
export function companyToFormValues(company: CompanyDetail): CompanyFormValues {
  return {
    ...sectionContextToFormValues(company),
    primary_customer_id: company.primary_customer?.id ?? '',
    company_admin_ids: company.company_admins?.map((admin) => admin.id) ?? [],
  };
}

/** Map validated form values onto an API company request payload. */
export function formValuesToRequest(values: CompanyFormValidated): CompanyRequest {
  return {
    ...buildSectionContextRequest(values),
    primary_customer_id: emptyToNull(values.primary_customer_id),
    company_admin_ids: values.company_admin_ids,
  };
}
